import { render } from "./Appointment.vue?vue&type=template&id=62de4462"
import script from "./Appointment.vue?vue&type=script&lang=ts"
export * from "./Appointment.vue?vue&type=script&lang=ts"

import "./Appointment.vue?vue&type=style&index=0&id=62de4462&lang=css"
script.render = render

export default script